import { actionDeclarer } from '../services/actionDeclarer';

export const {
	SET_TAG,
	SET_TAG_AUTH_SCOPES,
	SET_TAG_LIST,
	SET_TAG_TYPES
} = actionDeclarer;

const tagsReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case SET_TAG:
			return {
				...state,
				tag: payload
			};
		case SET_TAG_AUTH_SCOPES:
			return {
				...state,
				tagAuthScopes: payload
			};
		case SET_TAG_LIST:
			return {
				...state,
				tagList: payload
			};
		case SET_TAG_TYPES:
			return {
				...state,
				tagTypes: payload
			};

		default:
			return state;
	}
};

export default tagsReducer;
